import history from './../components/history';
import Url from 'url';
import debug from 'debug';

const log = debug('ro-webapp:router');

/**
 * @singleton
 */
class Router {
    constructor() {
        this.stack = [];
    }

    getRouteTo(screenInstance) {
        return '/' + screenInstance.code;
    }

    $push(route) {
        log('Pushing to history: ', route);
        this.stack.push(route);
        history.push(route);
    }

    $replace(route) {
        log('Replacing in history: ', route);
        this.stack[this.stack.length - 1](route);
        history.replace(route);
    }

    openScreen(screenInstance) {
        this.$push(this.getRouteTo(screenInstance));
    }

    showPlantDetailPage(plantId) {
        this.$push('/map/plants/' + plantId);
    }

    showMapWithMarker(markerId) {
        //TODO
        this.$push('/map/markers/' + markerId);
    }

    goBack() {
        if (this.stack.length === 0) {
            return;
        }
        log('Going back');
        history.goBack()
    }

    updateQueryParams(newParams) {
        let url = Url.parse(window.location.href);
        let currentParams = {};
        let params = new URLSearchParams(url.query);
        for (let key of params.keys()) {
            currentParams[key] = params.get(key);
        }
        currentParams = Object.assign(currentParams, newParams);
        let newQuery = [];
        Object.keys(currentParams).map((key) => {
            if (!key) {
                return;
            }
            console.log('jey: ', key);
            newQuery.push(`${key}=${currentParams[key]}`);
        });
        this.$push(`${url.pathname}?${newQuery.join('&')}`);
    }
}

export default new Router();


// WEBPACK FOOTER //
// ./src/core/router.js